




import Company from "@/models/company";
import { LayoutModule } from "@/store/layout";
import { Component, Vue } from "vue-property-decorator";
import CompanyForm from "./Components/CompanyForm.vue";
import CompanyAPI from "@/services/companies";

@Component({
  components: {
    CompanyForm,
  },
})
export default class NewCompany extends Vue {
  async save(company: Company): Promise<void> {
    LayoutModule.showLoader();
    LayoutModule.setAlerts([]);
    try {
      await CompanyAPI.newCompany(company);
      LayoutModule.setAlerts({
        text: this.$t("companies.responses.success_create").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }

    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "companies" });
  }
}
